// NL
export const dormerDefaultNL = {
  id: 'd26f935b-87d4-447e-a783-be395cc83675',
  identifier: 'dormer-default',
}
